export default __webpack_public_path__ + "static/media/address-icon.9e6ffbbb.svg";